import pipe from 'utils/pipe-fn'

// JS built-in can't be tested, so we ignore this
/* istanbul ignore next */
export function preloadImage (url, callback) {
  return new Promise((resolve, reject) => {
    const image = new Image()
    const hasCallback = typeof callback === 'function'

    image.onload = hasCallback ? pipe(callback, resolve) : resolve
    image.onerror = hasCallback ? pipe(callback, reject) : reject
    image.src = url
  })
}

export function preloadImages (urls, callback) {
  return Promise.all(
    urls.map((url, index) => {
      const useCallback = typeof callback === 'function' && index === urls.length - 1
      return preloadImage(url, useCallback ? callback : null)
    })
  )
}
